import type {
  IRecentAddressSuggestion,
  IRecentAddressSuggestionsApiResponse,
} from '@/common/interfaces/mostRecent.interface';

export const normalizeRecentAddressSuggestionsResponse = (
  response: IRecentAddressSuggestionsApiResponse | IRecentAddressSuggestion[] | unknown,
  limit = 3
): IRecentAddressSuggestion[] => {
  if (Array.isArray(response)) {
    return response.slice(0, limit);
  }

  if (
    response != null &&
    typeof response === 'object' &&
    'data' in response &&
    Array.isArray((response as IRecentAddressSuggestionsApiResponse).data)
  ) {
    return (response as IRecentAddressSuggestionsApiResponse).data.slice(0, limit);
  }

  return [];
};
